var _g, _circle, _circle2, _circle3, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "greeting-svg",
    width: "66mm",
    height: "64mm",
    viewBox: "0 0 66 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -22.429,
    y: -16.891,
    width: 143.99,
    height: 133.88,
    display: "inline",
    strokeWidth: 0.26458
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.371,
    cy: 19.586,
    r: 10.627,
    fill: "#2ec2c5",
    strokeWidth: 0.26458
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.188,
    cy: 27.575,
    r: 10.627,
    fill: "#b4598b",
    strokeWidth: 0.26458
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.327,
    cy: 52.525,
    r: 10.627,
    fill: "#6db860",
    strokeWidth: 0.26458
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.66552 0 0 .68078 8.946 10.778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.146 10.948-9.146-3.948v-4c0-0.897-1.103-1.355-1.718-0.703-5.776 6.118-8.282 19.703-8.282 19.703h12c0.552 0 1-0.448 1-1v-4h4.25c1.604-0.045 3.212-0.976 3.519-2.511 0.272-1.362-0.381-2.92-1.623-3.541z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.596 5.204c-0.948-0.474-2.104-0.133-2.627 0.789-1.44 2.538-3.99 7.565-4.853 14.897-0.07 0.59 0.402 1.11 0.997 1.11h1.887s1.761-9.538 5.73-16.229z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.081 8.762 2.19-5.949c0.214-0.641-0.636-1.086-1.041-0.546l-3.908 5.304z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.79978 0 0 .79978 23.792 42.638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 10-4.909 2.454c-0.896 0.448-0.65 1.79 0.348 1.889l6.561 0.657z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 9c-0.552 0-1-0.447-1-1v-4c0-0.553 0.448-1 1-1s1 0.447 1 1v4c0 0.553-0.448 1-1 1z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.999 11c-0.19 0-0.383-0.055-0.554-0.168-0.459-0.307-0.583-0.927-0.277-1.387l4-6c0.307-0.46 0.927-0.584 1.387-0.277 0.459 0.307 0.583 0.927 0.277 1.387l-4 6c-0.193 0.289-0.51 0.445-0.833 0.445z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.001 12c-0.367 0-0.72-0.202-0.896-0.553-0.247-0.494-0.047-1.095 0.447-1.342l6-3c0.496-0.245 1.095-0.046 1.342 0.447 0.247 0.494 0.047 1.095-0.447 1.342l-6 3c-0.143 0.072-0.296 0.106-0.446 0.106z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 4,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 8,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.282 9.077c-0.748-1.165-2.016-1.947-3.478-2.046-0.49-0.067-0.795 0.019-0.795 0.019-2.252 0.248-4.009 2.133-4.009 4.45 0 2.485 2.015 4.5 4.5 4.5 0.329 0 0.647-0.04 0.956-0.107-0.127 2.206-1.231 4.208-2.159 5.52-0.472 0.668-8e-3 1.587 0.809 1.587h5.94c0.534 0 0.98-0.425 1.002-0.959 0.293-7.25-1.126-11.011-2.766-12.964zm-4.282 2.923c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 1,
    opacity: 0.35
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.76453 0 0 .76453 46.284 18.034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 6c-2.209 0-4 1.567-4 3.5s1.791 3.5 4 3.5 4-1.567 4-3.5-1.791-3.5-4-3.5zm-2 4c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zm3 0c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10,9.5 7,7 C 7.62,5.601 8.624,4.976 9.298,4.702 9.635,4.566 10,4.811 10,5.174 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2,9.5 3.685,7.406 5,7 C 4.38,5.601 3.376,4.976 2.702,4.702 2.365,4.566 2,4.811 2,5.174 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 13.661c0-2.473-0.949-6.661-6-6.661-2.866 0-3.477 1.024-5.578 1.606-0.174-0.625-0.741-1.087-1.422-1.087-0.814 0-1.473 0.657-1.48 1.469-0.013 0-0.027 1e-3 -0.04 1e-3 -6e-3 -0.813-0.666-1.47-1.48-1.47-0.818 0-1.481 0.663-1.481 1.481s0.663 1.481 1.481 1.481c0.392 0 0.746-0.155 1.011-0.404l0.036 3.589h-0.047v7.333c0 0.552 0.448 1 1 1s0.937-0.451 1-1c0.042-0.366 0.482-3.568 0.764-5.618l0.236 0.035v5.584c0 0.552 0.448 1 1 1s0.937-0.451 1-1c0.04-0.346 0.436-3.233 0.717-5.28 0.056-0.351 0.364-1.72 1.783-1.72 1.527 0 1.765 1.942 1.765 1.942 0.282 2.037 0.694 4.704 0.735 5.058 0.063 0.549 0.448 1 1 1s1-0.448 1-1v-5.815c0.067-0.021 0.133-0.042 0.201-0.063 0.278 2.025 0.755 5.496 0.799 5.878 0.063 0.549 0.448 1 1 1s1-0.448 1-1v-7.333h-2e-3c0-2e-3 2e-3 -4e-3 2e-3 -6e-3z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.793,4 H 17 C 16.12,4 15.368,3.424 15.102,2.63 14.971,2.237 14.637,2 14.15,2 13.494,2 12.997,2.64 13.205,3.263 13.737,4.849 15.241,6 17,6 h 0.905 c 1.026,0 1.959,0.733 2.08,1.752 0.099,0.833 -0.311,1.516 -0.939,1.918 0.35,0.617 0.587,1.282 0.733,1.938 C 21.097,10.959 22.026,9.554 22,7.93 21.963,5.714 20.01,4 17.793,4 Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "text0",
    visibility: "hidden"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.39214,
    y: 0.59348,
    width: 22.682,
    height: 5.8085,
    fill: "#fff",
    fillOpacity: 0.2,
    strokeWidth: 0.28412
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.7221 6.3873h4.6204v4.6204z",
    fill: "#fff",
    fillOpacity: 0.2,
    strokeWidth: 0.14699
  }), /*#__PURE__*/React.createElement("text", {
    x: 1.4969785,
    y: 0,
    fill: "#ffffff",
    fontSize: "4.1584px",
    strokeWidth: 0.34653,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1.4969785,
    y: 5.2,
    fill: "#ffffff",
    strokeWidth: 0.34653
  }, "Welcome!")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "text1",
    visibility: "hidden"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.601,
    y: 9.4986,
    width: 26.318,
    height: 5.8085,
    fill: "#fff",
    fillOpacity: 0.2,
    strokeWidth: 0.30605
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.931 15.292h4.6204v4.6204z",
    fill: "#fff",
    fillOpacity: 0.2,
    strokeWidth: 0.14699
  }), /*#__PURE__*/React.createElement("text", {
    x: 39.705788,
    y: 13.950498,
    fill: "#ffffff",
    fontSize: "4.1584px",
    strokeWidth: 0.34653,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 39.705788,
    y: 14.10498,
    fill: "#ffffff",
    strokeWidth: 0.34653
  }, "Hello there!")))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "text2",
    visibility: "hidden"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.322,
    y: 33.874,
    width: 17.917,
    height: 5.8085,
    fill: "#fff",
    fillOpacity: 0.2,
    strokeWidth: 0.25252
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.652 39.668h4.6204v4.6204z",
    fill: "#fff",
    fillOpacity: 0.2,
    strokeWidth: 0.14699
  }), /*#__PURE__*/React.createElement("text", {
    x: 19.427114,
    y: 38.325748,
    fill: "#ffffff",
    fontSize: "4.1584px",
    strokeWidth: 0.34653,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19.427114,
    y: 38.125748,
    fill: "#ffffff",
    strokeWidth: 0.34653
  }, "Howdy!")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreeting);
export default __webpack_public_path__ + "static/media/greeting.fcbb1e6989b4a84a59bc7ecfc35cdeaa.svg";
export { ForwardRef as ReactComponent };